import * as Yup from "yup";
export const formInitialValues = {
  Loc_Auto_ID: "",  
  Plot_Auto_ID: "",
  Plant_Auto_ID: "",
  Report_For: "",
  Min_Date: "",
  Max_Date: "",
  Loc_Autocomplete_Name: "",
  Plot_Autocomplete_Name: "",
  Plant_Autocomplete_Name: "",
};

export const validationSchema = Yup.object().shape({
  Report_For: Yup.string().required("Request for is required"),
  // Plant_Status: Yup.string().required("Plant Status is required"),
  Min_Date: Yup.string(),
  Max_Date: Yup.string(),
  Loc_Autocomplete_Name: Yup.string(),
  Plot_Autocomplete_Name: Yup.string(),
  Plant_Autocomplete_Name: Yup.string(),
});

export function debounce(func, delay) {
  let timeoutId;

  return function (...args) {
    const context = this;

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
